import React from 'react'
import cognitoIcon from '../Assets/cognito-icon.png'
import { useNavigate } from 'react-router-dom'
import { useContext } from 'react';
import { ApiContext } from '../App';
import { AppContent } from '../context/AppContext';
import { toast } from 'react-toastify';
import { useEffect } from 'react';


const EmailVerify = () => {
  const navigate = useNavigate();
  const API = useContext(ApiContext);
  const {isLoggedin, userData, getUserData, fetchNotifications} = useContext(AppContent);

  const inputRefs = React.useRef([]);

  const handleInput = (e, index) => {
    if(e.target.value.length > 0 && index < inputRefs.current.length - 1){
      inputRefs.current[index + 1].focus();
    }
  }

  const handleKeyDown = (e, index) => {
    if(e.key === 'Backspace' && e.target.value === '' && index > 0){
      inputRefs.current[index - 1].focus();
    }
  }

  const handlePaste = (e) => {
    const paste = e.clipboardData.getData('text')
    const pasteArray = paste.split('');
    pasteArray.forEach((char, index)=>{
      if(inputRefs.current[index]){
        inputRefs.current[index].value = char;
      }
    })
  }

  const onSubmitHandler = async (e) => {
    try {
      e.preventDefault();
      const otpArray = inputRefs.current.map(e => e.value);
      const otp = otpArray.join('');

      const {data} = await API.post('/api/verify-account', {otp});
      if(data.success){
        toast.success(data.message);
        await getUserData();
        await fetchNotifications(); // Recharger les notifications
        navigate('/app');
      }else{
        toast.error(data.message);
      }
    } catch (error) {
      toast.error(error.message);
    }
  }

  useEffect(()=>{
    isLoggedin && userData && userData.isAccountVerified && navigate('/app')
  },[isLoggedin, userData])

  return (
    <div className='min-h-screen bg-gray-100'>
      {/* En-tête avec logo */}
      <div className='p-8'>
        <img 
          onClick={() => navigate('/')} 
          src={cognitoIcon} 
          alt="Cognito Logo" 
          className="w-12 h-12 cursor-pointer"
        />
      </div>
  
      {/* Conteneur centré pour le formulaire */}
      <div className='flex items-center justify-center min-h-[calc(100vh-132px)]'>
        <form 
          onSubmit={onSubmitHandler} 
          className='bg-slate-900 p-8 rounded-lg shadow-lg w-96 text-sm'
        >
          <h1 className='text-white text-2xl font-semibold text-center mb-4'>
            Email Verify OTP
          </h1>
          <p className='text-center mb-6 text-indigo-300'>
            Enter the 6 digit code sent to your email.
          </p>
          <div className='flex justify-between mb-8' onPaste={handlePaste}>
            {Array(6).fill(0).map((_, index) => (
              <input 
                type="text" 
                maxLength='1' 
                key={index} 
                required
                className='w-12 h-12 bg-[#333A5C] text-white text-center text-xl rounded-md'
                ref={e => inputRefs.current[index] = e}
                onInput={(e) => handleInput(e, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
              />
            ))}
          </div>
          <button className='w-full py-3 bg-gradient-to-r from-indigo-500 to-indigo-900 text-white rounded-full'>
            Verify email
          </button>
        </form>
      </div>
    </div>
  );
}

export default EmailVerify